@use '@/styles/tokens' as *;

// Neutral status pill (Figma 5740-704706): white-100 fill, fully-rounded, label +
// caret inside. Replaces the intent-coloured status chip in the detail header.
.pill {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2); // ~design 10px label↔caret
  padding: var(--space-1) 10px var(--space-1) var(--space-3); // 4px 10px 4px 12px
  background: $color-white-100;
  border: none;
  border-radius: var(--radius-pill);
  cursor: pointer;
  color: $color-neutral-950;
  font-size: 13px;
  line-height: 1;
  white-space: nowrap;
  height: 40px;
}

// Final statuses (Delivered/Cancelled): same pill, no caret, non-interactive.
.static {
  cursor: default;
}

.icon {
  width: 76px;
  height: 76px;
  object-fit: contain;
  z-index: 1;
}

.subtitle {
  display: inline-block;
  max-width: 269px;
}

.cancelSubtitle {
  display: inline-block;
  max-width: 319px;
}
